// import { gsap } from 'gsap';
// import { Observer } from 'gsap/dist/Observer';
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import Swiper from 'swiper/bundle';

// gsap.registerPlugin(Observer, ScrollToPlugin);

// Initialize Swiper instance for the slider
const buildSwiperSlider = sliderElm => {
    const sliderIdentifier = sliderElm.dataset.id;
    return new Swiper(`#${sliderElm.id}`, {
        slidesPerView: 1,
        spaceBetween: 24,
        autoHeight: false,
        loop: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: `#swiper-navigation-${sliderIdentifier} .swiper-button-next`,
            prevEl: `#swiper-navigation-${sliderIdentifier} .swiper-button-prev`,
        },
        pagination: {
            el: `#swiper-pagination-${sliderIdentifier}`,
            clickable: true,
        },
        speed: 1000
    });
};

$(document).ready(function () {
    // Iterate through each slider container on the page
    $('.slider .swiper-container').each((_, sliderEl) => {
        const section = sliderEl.closest('.slider');
        if (!section) return;

        const swiper = buildSwiperSlider(sliderEl);

        // let isLocked = false;
        // const canHover = window.matchMedia('(hover: hover)').matches;
        //
        // if(canHover) {
        //     // Create Observer to intercept wheel events and control slider behavior
        //     const scrollObserver = Observer.create({
        //         target: window,
        //         type: 'wheel',
        //         preventDefault: true,
        //         enabled: true,
        //         onChangeY: self => {
        //             const delta = self.deltaY;
        //             const viewportCenter = window.innerHeight / 2;
        //             const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        //             const sectionTop = section.offsetTop;
        //             const sectionHeight = section.offsetHeight;
        //             const lockThreshold = sectionTop + sectionHeight / 2 - viewportCenter;
        //             const remaining = lockThreshold - scrollY;
        //             const leftover = delta - remaining;
        //
        //             if(Math.abs(remaining) > Math.abs(delta)) {
        //                 isLocked = false;
        //                 window.scrollBy({
        //                     top: delta,
        //                     left: 0,
        //                     behavior: "auto",
        //                 });
        //                 return;
        //             }
        //
        //             if (!isLocked) {
        //                 if((Math.abs(remaining) <= Math.abs(delta)) && ((leftover > 0 && !swiper.isEnd) || (leftover <= 0 && !swiper.isBeginning))) {
        //                     // Smooth scroll to lock threshold with customizable duration
        //                     gsap.to(window, { scrollTo: lockThreshold, duration: 0.1 });
        //                     isLocked = true;
        //                     // console.log('Lock engaged');
        //                     return;
        //                 }
        //
        //                 window.scrollBy({
        //                     top: delta,
        //                     left: 0,
        //                     behavior: "auto",
        //                 });
        //             } else {
        //                 // Locked: all wheel delta now controls the slider
        //                 // console.log('scroll locked, delta for slider:', delta);
        //                 // If user scrolls down on the last slide — unlock scrolling
        //                 if (delta > 0 && swiper.isEnd) {
        //                     // console.log('Unlock: reached last slide and scrolling down');
        //                     isLocked = false;
        //                     return;
        //                 }
        //                 // If user scrolls up on the first slide — unlock scrolling
        //                 if (delta < 0 && swiper.isBeginning) {
        //                     // console.log('Unlock: reached first slide and scrolling up');
        //                     isLocked = false;
        //                     return;
        //                 }
        //
        //                 // Control slider navigation
        //                 if (delta > 0 && !swiper.animating) swiper.slideNext();
        //                 else if (delta < 0 && !swiper.animating) swiper.slidePrev();
        //             }
        //         }
        //     });
        //
        //     // Activate the Observer immediately (scroll lock controlled by `isLocked`)
        //     scrollObserver.enable();
        // }
    });
});
